import React from 'react';
import { pure, compose, branch, renderNothing } from 'recompose';
import classNames from 'classnames';
import Link from 'components/general/Link/Link';
import LinkProps from 'utils/ts/LinkProps';

const TOTAL_SEGMENTS = 5;

const RiskBar: React.SFC<RiskBarPropDef> = ({
  rating,
  label,
  ratingLabel,
  iso,
  to,
}) => {
  const Wrapper = to ? Link : 'div';

  return (
    <Wrapper className="risk-rating-bar" to={to}>
      <div className="risk-rating-bar__country">
        {iso && (
          <span className={`flag-icon flag-icon--${iso.toLowerCase()} risk-rating-bar__flag`} />
        )}
        <span className="risk-rating-bar__label">{label}</span>
      </div>
      <div className="risk-rating-bar__chart">
        <div className="risk-rating-bar__segments">
          {Array.from({ length: TOTAL_SEGMENTS }, (_, i) => (
            <span
              key={i}
              className={classNames('risk-rating-bar__segment', {
                [`risk-rating-bar__segment--risk-${rating}`]: i < rating,
                'risk-rating-bar__segment--empty': i >= rating,
              })}
            />
          ))}
        </div>
        {ratingLabel && (
          <span className="risk-rating-bar__rating-label">{ratingLabel}</span>
        )}
      </div>
    </Wrapper>
  );
};

export interface RiskBarPropDef {
  rating: 1 | 2 | 3 | 4 | 5;
  label?: string;
  ratingLabel?: string;
  iso?: string;
  to?: LinkProps;
}

export default compose(
  branch(
    (props: RiskBarPropDef) => !props.rating,
    renderNothing,
  ),
)(pure(RiskBar));
